import { GeneralConstants } from 'app/constants/general-constants';
import { healthService } from 'app/services/tools/health.service';
import { mccService } from 'app/services/tools/mcc.service';
import { AppThunk } from 'app/store';

import { setHealthData, setMccLookupData, setSeamHealth } from './slice';

export const fetchHealthData = (): AppThunk => (dispatch) => {
    healthService.fetch().subscribe((data) => {
        dispatch(setHealthData(data));
    });

    healthService.fetchSeam().subscribe((data) => {
        dispatch(setSeamHealth(data));
    });
};

export const searchMccData =
    (search: string): AppThunk =>
    (dispatch) => {
        dispatch(setMccLookupData(undefined));
        mccService
            .listAll({ queryFilters: { search }, pageSize: GeneralConstants.PAGE_SIZE_HUGE })
            .subscribe((mccs) => {
                dispatch(setMccLookupData(mccs));
            });
    };
